<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <a class="close-btn cursor-pointer" (click)="close()"><i class="ri-close-fill"></i></a>
  </div>
  <mat-dialog-content>
    <div class="text-center">
      <form novalidate (ngSubmit)="confirmRejection()">
        <!-- Icon -->
        <div class="icon-circle-danger mx-auto mb-3">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
        </div>

        <h5 class="text-white fw-bold mb-2">Reject Support Ticket</h5>
        
        <p class="fs-7 mb-3 text-light-gray">
          Are you sure you want to mark ticket <span class="fw-bold text-white">{{ ticketId }}</span> as
          <span class="text-danger fw-bold">Rejected</span>?
        </p>

        <div class="shift-info-card p-3 rounded mb-3 text-start">
          <!-- Metadata Summary Section -->
          <div class="metadata-box pb-2 mb-3 border-bottom-dark" *ngIf="!isOtherCategory ">
            <div class="d-flex align-items-center justify-content-between mb-2" *ngIf="sku">
              <span class="field-label">SKU</span>
              <span class="field-value-highlight text-white fw-medium">{{ sku }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2" *ngIf="binderName">
              <span class="field-label">BINDER NAME</span>
              <span class="field-value text-white fw-medium">{{ binderName }}</span>
            </div>
          </div>

          <!-- Input Field for Rejection Reason / Admin Notes -->
          <div class="admin-notes-field-group">
            <label for="rejectionNotes" class="field-label text-white fw-semibold mb-2 d-block">
              REJECTION REASON  <span class="text-danger">*</span>
            </label>
            <textarea
              id="rejectionNotes"
              name="rejectionNotes"
              class="form-control rejection-textarea dark-input"
              rows="3"
              placeholder="Enter reason for rejecting ticket (e.g. Invalid receipt image, unreadable documents)..."
              [(ngModel)]="adminNotes"
              required
            ></textarea>
            <span class="field-subtext text-white fw-medium fs-8 mt-2 d-block">
              This note will be saved with the ticket and sent in the rejection email to the user.
            </span>
          </div>
        </div>

        <div class="d-flex align-items-center mt-4 flex-wrap justify-content-center gap-3">
          <button matButton="filled" type="button" class="dialog-btn-secondary" (click)="close()">Cancel</button>
          <button matButton="filled" type="submit" class="dialog-btn-danger" [disabled]="!adminNotes.trim()">
            Reject Ticket & Send Email
          </button>
        </div>
      </form>
    </div>
  </mat-dialog-content>
</div>
